import { Reveal } from "./Reveal";
import { Layers, Send, Sprout, ShieldCheck } from "lucide-react";

const principles = [
  {
    icon: Layers,
    title: "Diversificación Financiera Total",
    body: "Operamos un ecosistema robusto que integra arrendadoras, empresas de factoraje, sociedades de inversión de capitales y autofinanciamiento, resolviendo cualquier necesidad corporativa de liquidez.",
    span: "md:col-span-8",
    image:
      "https://customer-assets.emergentagent.com/job_balance-perfecto-pro/artifacts/zjrfl9cc_diversificacion-financiera.webp",
  },
  {
    icon: Send,
    title: "Infraestructura de Dispersión y Pago",
    body: "Contamos con tecnología de punta como transmisores y dispersores de dinero, garantizando un flujo de fondos ágil, seguro y auditable para la administración de nóminas, cajas de pensión o coberturas.",
    span: "md:col-span-4",
    image:
      "https://customer-assets.emergentagent.com/job_balance-perfecto-pro/artifacts/qvg66v7g_infraestructura-dispersion.webp",
  },
  {
    icon: Sprout,
    title: "Inclusión y Desarrollo Rural-Comunitario",
    body: "Diseñamos y operamos organismos de integración financiera rural, sociedades populares y comunitarias, llevando el crédito productivo a sectores estratégicos donde la banca tradicional no llega.",
    span: "md:col-span-4",
    image:
      "https://customer-assets.emergentagent.com/job_balance-perfecto-pro/artifacts/ye2tcnna_inclusion-desarrollo.webp",
  },
  {
    icon: ShieldCheck,
    title: "Estructuración Legal y Valuación de Alta Precisión",
    body: "Respaldamos cada movimiento con fideicomisos financieros y sociedades valuadoras propias, lo que nos permite certificar el valor real de los activos y blindar jurídicamente el patrimonio de nuestros inversionistas.",
    span: "md:col-span-8",
    image:
      "https://customer-assets.emergentagent.com/job_balance-perfecto-pro/artifacts/wpi355y6_estructuracion-legal.webp",
  },
];

export const Principios = () => {
  return (
    <section
      id="principios"
      data-testid="principios-section"
      className="relative bg-[#F7F6F1] py-24 md:py-36"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24 items-end">
          <div className="col-span-12 md:col-span-7">
            <Reveal>
              <div className="flex items-center gap-3 text-[#017766] mb-6">
                <span className="h-px w-10 bg-[#017766]" />
                <span className="overline">Distintivos</span>
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl md:text-6xl leading-[1.04] text-[#17351D]">
                Distintivos <br />
                <em className="text-[#017766]">Lex Balance</em>.
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-5">
            <Reveal delay={0.1}>
              <p className="text-base md:text-lg text-[#17351D]/65 leading-relaxed md:text-right">
                Cuatro fortalezas que nos diferencian como grupo integrador
                financiero no bursátil al servicio de inversionistas, despachos
                y empresas.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6 auto-rows-fr">
          {principles.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.title} delay={i * 0.06} className={`col-span-1 ${p.span}`}>
                <article
                  data-testid={`principle-card-${i}`}
                  className="principle-card group relative h-full overflow-hidden p-8 md:p-10 flex flex-col justify-between min-h-[300px] text-white border border-[#17351D]/20"
                >
                  {/* Background image */}
                  <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                    style={{ backgroundImage: `url(${p.image})` }}
                    aria-hidden="true"
                  />
                  {/* Dark overlay for readability */}
                  <div
                    className="absolute inset-0 bg-gradient-to-t from-[#17351D]/95 via-[#17351D]/80 to-[#17351D]/55 transition-opacity duration-500 group-hover:from-[#17351D]/90 group-hover:via-[#17351D]/70 group-hover:to-[#17351D]/40"
                    aria-hidden="true"
                  />

                  <div className="relative flex items-start justify-between">
                    <div className="w-12 h-12 border border-white/30 flex items-center justify-center text-[#C1C82A] backdrop-blur-sm bg-white/5">
                      <Icon size={20} strokeWidth={1.6} />
                    </div>
                    <span className="font-display text-3xl text-white/25">
                      0{i + 1}
                    </span>
                  </div>
                  <div className="relative mt-10">
                    <h3 className="font-display text-2xl md:text-[28px] text-white mb-4 leading-tight">
                      {p.title}
                    </h3>
                    <p className="text-[15px] text-white/85 leading-relaxed">
                      {p.body}
                    </p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Principios;
